




















import { defineComponent } from '@vue/composition-api';
import { DashboardWidgetHeaderColor } from '../../../../types/enums/dashboard-widget-header-color';
import DashboardWidgetList from '../../../../components/DashboardWidgetList.vue';
import DashboardEmptyStateText from '../../../../components/DashboardEmptyStateText.vue';
import { useDashboardActivities } from '../../../../composables/dashboard-activities.composable';
import DashboardWidgetListSkeleton from '../../../../components/skeletons/DashboardWidgetListSkeleton.vue';
import LatestActivitiesWidgetItem from '../../../../components/widgets/latest-activity/LatestActivitiesWidgetItem.vue';

export default defineComponent({
  name: 'LatestActivitiesWidget',
  components: {
    DashboardWidgetList,
    LatestActivitiesWidgetItem,
    DashboardEmptyStateText,
    DashboardWidgetListSkeleton,
  },
  props: {
    showAll: {
      type: Boolean,
    },
  },
  setup(props) {
    const { data: activities, isLoading, isSuccess } = useDashboardActivities(props.showAll);

    return {
      DashboardWidgetHeaderColor,
      activities,
      isLoading,
      isSuccess,
    };
  },
});
